var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "evaluate" }, [
    _c(
      "div",
      { staticClass: "banxin" },
      [
        _c(
          "div",
          { staticClass: "head" },
          [
            _c("router-link", { attrs: { to: "/myOrder" } }, [
              _c("div", { staticClass: "all" }, [_vm._v("我的订单")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c("div", { staticClass: "keyword" }, [_vm._v("评价")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm._l(_vm.product.skus, function(item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.commentId === 0,
                      expression: "item.commentId === 0"
                    }
                  ],
                  key: index,
                  staticClass: "top"
                },
                [
                  _c("div", { staticClass: "left" }, [
                    _c("div", { staticClass: "box" }, [
                      _c("img", { attrs: { src: item.image, alt: "" } }),
                      _vm._v(" "),
                      _c("p", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.productName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price" }, [
                        _c("span", { staticClass: "currency" }, [_vm._v("¥")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "money" }, [
                          _vm._v(_vm._s(item.price))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "size" },
                        _vm._l(item.values, function(val, idx) {
                          return _c("span", { key: idx }, [_vm._v(_vm._s(val))])
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("填写商品评价：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          refInFor: true,
                          attrs: { "label-width": "80px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              },
                              attrs: { label: "商品满意度评分" }
                            },
                            [
                              _c("el-rate", {
                                staticStyle: { "margin-left": "110px" },
                                attrs: { colors: _vm.colors },
                                on: { change: _vm.changeScore },
                                model: {
                                  value: item.score,
                                  callback: function($$v) {
                                    _vm.$set(item, "score", $$v)
                                  },
                                  expression: "item.score"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品印象" } },
                            _vm._l(_vm.tag, function(tagItem, tagIndex) {
                              return _c(
                                "div",
                                {
                                  key: tagIndex,
                                  staticClass: "tag",
                                  class:
                                    item.impression.indexOf(tagItem) != -1
                                      ? "active"
                                      : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.tagClick(tagItem, index)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tagItem))]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "评价晒单" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "请输入您的评语",
                                  rows: "5",
                                  resize: "none"
                                },
                                model: {
                                  value: item.text,
                                  callback: function($$v) {
                                    _vm.$set(item, "text", $$v)
                                  },
                                  expression: "item.text"
                                }
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: _vm.action,
                                    "list-type": "picture-card",
                                    limit: 5,
                                    "on-success": function(res, file) {
                                      return _vm.handSuccess(res, file, index)
                                    },
                                    "on-remove": function(file, fileList) {
                                      return _vm.handleRemove(
                                        file,
                                        fileList,
                                        index
                                      )
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-plus" })]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "imgNum" }, [
                                _vm._v("\n                共"),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(_vm._s(item.imgNum))
                                ]),
                                _vm._v("张，还可以上传"),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(_vm._s(5 - item.imgNum))
                                ]),
                                _vm._v("张\n              ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom" },
              [
                _c(
                  "el-button",
                  {
                    directives: [{ name: "throttle", rawName: "v-throttle" }],
                    attrs: { plain: "" },
                    on: { click: _vm.addComment }
                  },
                  [_vm._v("提交评价")]
                )
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.centerDialogVisible,
              width: "30%",
              "show-close": false,
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.centerDialogVisible = $event
              }
            }
          },
          [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("../../../static/image/wancheng@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("您的评价已成功提交")])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _vm.product.collageId == 0
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          { name: "throttle", rawName: "v-throttle" }
                        ],
                        staticClass: "again",
                        on: {
                          click: function($event) {
                            return _vm.buyAgain()
                          }
                        }
                      },
                      [_vm._v("再次购买")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "back",
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/")
                      }
                    }
                  },
                  [_vm._v("返回首页")]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1a03ca76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1a03ca76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluate/index.vue
// module id = null
// module chunks = 